import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useLess } from '@/models/hooks';
import constants from '@/constants';
import { ref, nextTick, watch } from 'vue';
import { LOGINTOOLTIP_ID } from '@/configs/views/landingPage.js';
export default {
  __name: 'LoginTooltip',
  props: ['isShow', 'showPageType', 'style'],
  emits: ['handleLogin'],
  setup(__props, {
    emit: emits
  }) {
    var props = __props;
    useLess('components/LoginTooltip.less');
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var store = useStore();
    var loginTooltipRef = ref(null);
    var NEW_IMAGE_URL = constants.NEW_IMAGE_URL,
      IMAGE_URL = constants.IMAGE_URL;
    var BADGE_LOGO_URL = `${NEW_IMAGE_URL}04_BadgeLogo/Logo_Settings3x.png`;
    var LOGO_URL = {
      gateway: `${IMAGE_URL}assets/image/hLogo.png`,
      detailPage: `${IMAGE_URL}assets/image/icon-app-logo.png`
    };
    var BUTTON_TEXT = {
      gateway: t('modules.commonComponent.LOGIN_TOOLTIP.BUTTON_TEXT'),
      detailPage: t('modules.commonComponent.LOGIN_TOOLTIP.OPEN_APP')
    };
    watch(() => props.isShow, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(isShow) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isShow) {
                _context.next = 4;
                break;
              }
              _context.next = 3;
              return nextTick();
            case 3:
              store.commit(`common/setLoginTooltipHeight`, loginTooltipRef.value.clientHeight);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _component_van_image = _resolveComponent("van-image");
      var _component_van_button = _resolveComponent("van-button");
      return __props.isShow ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`${__props.showPageType}-login-wrapper`),
        ref_key: "loginTooltipRef",
        ref: loginTooltipRef,
        style: _normalizeStyle(__props.style)
      }, [_createElementVNode("div", {
        class: _normalizeClass(`${__props.showPageType}-login-box`)
      }, [_createElementVNode("div", {
        class: _normalizeClass(`${__props.showPageType}-login-logo`)
      }, [_createVNode(_component_van_image, {
        src: LOGO_URL[__props.showPageType],
        fit: "contain"
      }, null, 8, ["src"])], 2), _createElementVNode("div", {
        class: _normalizeClass(`${__props.showPageType}-login-main`)
      }, [_createVNode(_component_van_image, {
        src: BADGE_LOGO_URL,
        fit: "contain"
      }), _createElementVNode("div", {
        class: _normalizeClass(`${__props.showPageType}-login-main-text`)
      }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.commonComponent.LOGIN_TOOLTIP.TEXT')), 1)], 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(`${__props.showPageType}-login-button`)
      }, [_createVNode(_component_van_button, {
        round: "",
        id: _unref(LOGINTOOLTIP_ID),
        onClick: _cache[0] || (_cache[0] = $event => emits('handleLogin'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(BUTTON_TEXT[__props.showPageType]), 1)]),
        _: 1
      }, 8, ["id"])], 2)], 2)], 6)) : _createCommentVNode("", true);
    };
  }
};